import { Autocomplete, Box, ToggleButton, ToggleButtonGroup, Divider, FormControl, TextField } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import { observationFilterState, observationViewState } from '../../atoms';
import { ObservationsList } from './ObservationsList';
import { ObservationsMap } from './ObservationsMap';
import { useObservations } from '../../hooks/useObservations';
import { useStationFilter } from '../../hooks/useStationFilter';

export const Observations = () => {
    const [view, setView] = useAtom(observationViewState);
    const { data: observations = [], isFetched } = useObservations();

    const stationNames = useMemo(() => [...new Set(observations.map(({ station: { name } }) => name))].sort(), [observations]);
    const { selectedNames, handleSetFilter } = useStationFilter(observationFilterState, stationNames);

    const filteredObservations = useMemo(() => {
        if (selectedNames.length > 0) {
            return observations.filter(({ station: { name } }) => selectedNames.includes(name));
        }

        return observations;
    }, [selectedNames, observations]);

    if (!isFetched) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    p: 2,
                    gap: 2,
                }}>
                <FormControl fullWidth variant="outlined" sx={{ maxWidth: (theme) => theme.breakpoints.values.sm }}>
                    <Autocomplete
                        multiple
                        id="filter-stations"
                        options={stationNames}
                        value={selectedNames}
                        onChange={handleSetFilter}
                        filterSelectedOptions={true}
                        disableCloseOnSelect
                        renderInput={(params) => <TextField {...params} variant="outlined" label="Filter Stations" />}
                    />
                </FormControl>
                <ToggleButtonGroup value={view} exclusive size="large" onChange={(_, val) => val && setView(val)}>
                    <ToggleButton value="map">
                        <MapIcon sx={{ mr: 0.5 }} />
                        Map
                    </ToggleButton>
                    <ToggleButton value="list">
                        <TableRowsIcon sx={{ mr: 0.5 }} />
                        List
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>
            <Divider />
            {view === 'map' && <ObservationsMap observations={filteredObservations} />}
            {view === 'list' && <ObservationsList observations={filteredObservations} />}
        </Box>
    );
};
